import { render } from "./SnackComponent.vue?vue&type=template&id=e58fc396&scoped=true"
import script from "./SnackComponent.vue?vue&type=script&lang=js"
export * from "./SnackComponent.vue?vue&type=script&lang=js"

import "./SnackComponent.vue?vue&type=style&index=0&id=e58fc396&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58fc396"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QSpace,QBtn});
